import React from 'react'
import ReactDOM from 'react-dom/client'
import { ThemeProvider } from '@alefeducation/ui-elements-library-core'
import { asyncWithLDProvider } from 'launchdarkly-react-client-sdk'
import App from './App'

// wrap the root with Lauch darkly context
async function renderAppWithLD() {
  const context = {
    kind: 'user',
    key: 'global-search-frontend'
  }

  const LDProvider = await asyncWithLDProvider({
    clientSideID: window.AppConfig.LAUNCH_DARKLY_CLIENT_ID || '',
    context
  })

  const root = ReactDOM.createRoot(document.getElementById('root'))
  root.render(
    <LDProvider>
      <ThemeProvider>
        <App />
      </ThemeProvider>
    </LDProvider>
  )
}

renderAppWithLD()
